import React from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import { useIsCoreLoadingByFilterChange, useIsLoadingNextPage } from '../../../services/core-data';
import MaxPaginationWarning from './max-pagination-warning';
import messages from './messages';

const IssueTitle = () => {
	const isLoadingByFilterChange = useIsCoreLoadingByFilterChange();
	// TODO: Only display this if we are paginating due to a horizontal scroll.
	// For vertical scrolls, there'll already be a spinner shown at the bottom
	// of the table.
	const isLoadingNextPage = useIsLoadingNextPage();
	const { formatMessage } = useIntl();
	return (
		<IssueTitleContainer>
			{formatMessage(messages.issues)}
			<MaxPaginationWarning />
			{isLoadingByFilterChange ||
				(ff('use-ags-for-deployments-timeline_22xgj') && isLoadingNextPage && (
					<Box xcss={spinnerWrapperStyles}>
						<Spinner size="small" />
					</Box>
				))}
		</IssueTitleContainer>
	);
};

export default IssueTitle;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IssueTitleContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	height: '100%',
	fontWeight: 'bold',
});

const spinnerWrapperStyles = xcss({
	marginLeft: 'space.100',
});
